import { render, staticRenderFns } from "./vipData.vue?vue&type=template&id=1c6371f3"
import script from "./vipData.vue?vue&type=script&lang=js"
export * from "./vipData.vue?vue&type=script&lang=js"
import style0 from "./vipData.vue?vue&type=style&index=0&id=1c6371f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports